import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import { LineChart } from '@mui/x-charts'
import styles from '../SuperAdminDashboard.module.scss'

const ACCOUNT_KEYS = [
	'user',
	'vendor',
	'kazoo-planner',
	'vendor-staff',
	'account',
	'other',
]

const ACCOUNT_LABELS = {
	user: 'Users',
	vendor: 'Vendors',
	'kazoo-planner': 'Planners',
	'vendor-staff': 'Vendor staff',
	account: 'Accounts (base)',
	other: 'Other',
}

const ACCOUNT_SERIES_COLORS = [
	'#7ca6bd',
	'#5a8aa3',
	'#4a6d85',
	'#a8c4d8',
	'#9aa4b3',
	'#e1d4cf',
]

export function AdminAccountsChartCard() {
	const accountsByWeekSeries = useSelector(
		(s) => s.admin.accountsByWeekSeries
	)
	const accountsByWeekChartLoading = useSelector(
		(s) => s.admin.accountsByWeekChartLoading
	)
	const accountsByWeekChartError = useSelector(
		(s) => s.admin.accountsByWeekChartError
	)

	const accountsDataset = useMemo(() => {
		const ser = accountsByWeekSeries
		if (!Array.isArray(ser)) return []
		return ser.map((row) => {
			const o = { week: row.weekStart }
			for (const k of ACCOUNT_KEYS) {
				o[k] = row.byType?.[k] ?? 0
			}
			return o
		})
	}, [accountsByWeekSeries])

	const accountsSeries = useMemo(
		() =>
			ACCOUNT_KEYS.map((key, i) => ({
				dataKey: key,
				label: ACCOUNT_LABELS[key],
				curve: 'monotone',
				showMark: false,
				color: ACCOUNT_SERIES_COLORS[i % ACCOUNT_SERIES_COLORS.length],
			})),
		[]
	)

	return (
		<div className={styles.chartCard}>
			<h2 className={styles.chartCardTitle}>Accounts created by week</h2>
			<p className={styles.chartCaption}>
				By user type (UTC weeks, last 104 weeks). Excludes dummy accounts.
			</p>
			{accountsByWeekChartLoading ? (
				<p className={styles.chartPlaceholder}>Loading…</p>
			) : accountsByWeekChartError ? (
				<p className={styles.statsErrorInline}>
					{accountsByWeekChartError}
				</p>
			) : accountsDataset.length === 0 ? (
				<p className={styles.chartPlaceholder}>No data</p>
			) : (
				<Box className={styles.chartInner}>
					<LineChart
						dataset={accountsDataset}
						xAxis={[
							{
								dataKey: 'week',
								scaleType: 'point',
								label: 'Week (UTC start)',
							},
						]}
						series={accountsSeries}
						grid={{ horizontal: true, vertical: false }}
						margin={{
							top: 48,
							right: 12,
							bottom: 48,
							left: 48,
						}}
						height={320}
					/>
				</Box>
			)}
		</div>
	)
}
